<template>
  <div class="tablelist">
     <modal
            name="CaseModal"
            width="50%"
            height="auto"
            :scrollable="true"
            :adaptive="true"
            :clickToClose="true"
            style="overflow:scroll"
        >
        <div>
          <div class="titleRefZone">{{this.TitleResumen}}</div>
          <div class="infoForm" v-for="itemdata of this.tempDataForm" :key="itemdata.id">
            <div><strong>{{itemdata.detail}}</strong></div>
            <div>{{itemdata.value}}</div>
          </div>
        </div>
     </modal>
    <div class="row align--center">
    </div>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :per-page="parseInt(perPage)"
      no-data-label="No se encuentran datos para esta busqueda"
    >
      <template slot="courseList" slot-scope="props">
        <ul class="listUL" v-for="itemdata of JSON.parse(props.rowData.Det_Courses)" :key="itemdata.id">
          <li>{{itemdata.CFPC_Name}}</li>
        </ul>
      </template>
      <template slot="detailList" slot-scope="props">
        <div>
            {{props.rowData.Det_Message.split(" | ")[0]}}
            <br>
            <span class="redSub">{{props.rowData.Det_Message.split(" | ")[1]}}</span>
        </div>
      </template>
      <template slot="detailForm" slot-scope="props">
        <div>
          <img class="imgdata ma-0" src="../../assets/images/detail.png" width="20" alt="Detalle" title="Detalle" @click="viewDetail(props.rowData.Det_Courses)" />
        </div>
      </template>
      <template slot="status" slot-scope="props">
        <img class="imgdata ma-0" src="../../assets/images/user_check.png" width="20" alt="Activo" title="Activo" v-if="props.rowData.CaseStatus === true"/>
        <img class="imgdata ma-0" src="../../assets/images/user_inactive.png" width="20" alt="Inactivo" title="Inactivo" v-else/>
      </template>
      <template slot="dateCreted" slot-scope="props">
        <div class="datime">{{valDate(props.rowData.Date_Created)}}</div>
      </template>
      <template slot="dateCretedIni" slot-scope="props">
        <div class="datime">{{valDatetime(props.rowData.DateStartCase)}}</div>
      </template>
      <template slot="dateCretedFin" slot-scope="props">
        <div class="datime">{{valDatetime(props.rowData.DateEndCase)}}</div>
      </template>
      <template slot="statusCases" slot-scope="props">
        <img class="imgdata ma-0" src="../../assets/images/user_check.png" width="20" alt="Activo" title="Activo" v-if="props.rowData.Sta_Status === true"/>
        <img class="imgdata ma-0" src="../../assets/images/user_inactive.png" width="20" alt="Inactivo" title="Inactivo" v-else/>
      </template>
      <template slot="actions" slot-scope="props">
        <div v-for="item of fields[fields.length-1].actionRef" :key="item.id">
          <template v-if="item.action === 'edit'">
            <router-link :to="'UpdateCase/'+props.rowData.CaseId"><img class="imgdata ma-0" :id="props.rowData.CaseId" src="../../assets/images/edit.png" alt="Editar" title="Editar" width="20"/></router-link>
          </template>
        </div>
      </template>
    </va-data-table>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import IberoHelpers from '@/store/helpers.js'

export default {
  data () {
    return {
      term: null,
      perPage: '20',
      tempDataForm: {},
      TitleResumen: '',
      perPageOptions: ['4', '6', '10', '20'],
      StatusOptions: [
        {
          id: 1,
          description: 'Activo',
        },
        {
          id: 2,
          description: 'Inactivo',
        },
      ],
      StatusOptionsModel: '',
      users: this.InfoView,
    }
  },
  props: {
    method: Function,
    InfoView: Array,
    HeadTable: Array,
  },
  computed: {
    fields () {
      return this.HeadTable
    },
    filteredData () {
      if (((!this.term) || (this.term.length < 1)) && (!this.StatusOptionsModel.id)) {
        return this.users
      }
      return this.users.filter(item => {
        if (this.term && this.term.length >= 1) {
          return item.idBanner.toLowerCase().startsWith(this.term.toLowerCase())
        } else {
          return item
        }
      }).filter(item => {
        switch (this.StatusOptionsModel.id) {
          case 1:
            return item.staStatus === true
          case 2:
            return item.staStatus === false
          default:
            return item
        }
      })
    },
  },
  methods: {
    viewDetail (infoDetail) {
      this.tempDataForm = JSON.parse(infoDetail)
      this.TitleResumen = 'Encuesta Satisfacción'
      this.$modal.show('CaseModal')
    },
    valDate (datime) {
      return IberoHelpers.dataObjDate(datime)
    },
    valDatetime (datime) {
      return IberoHelpers.dataTimeObjDate(datime)
    },
    dataReg (user, ref) {
      this.method(user, ref)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
}
</script>

<style>
.tablelist .va-button {
  color: #222 !important;
  border-color: #222 !important;
}

.tablelist .va-button--active {
  color: #ffffff !important;
  border-color: #222 !important;
  background-color: #222 !important;
}

.tablelist .va-select__label {
  color: #222 !important;
}
.va-select__option--selected {
  color: #222 !important;
}

.tablelist .va-button--small .va-button__content__title {
  color: #222 !important;
}

.va-table th,
.content table th {
  border-bottom: 2px solid #222 !important;
  font-size: 12px !important;
}

.va-data-table__vuetable th.sortable {
  color: #222 !important;
}

.imgdata{
  cursor: pointer;
  margin-left: 2px !important;
  margin-right: 2px !important;
}

ul.listUL {
    width: 300px !important;
  list-style-type: square;
}

.datime{
  width: 150px !important;
}

.redSub {
  font-weight: bold;
  font-size: 12px;
  font-style: italic;
}

.infoForm{
  padding: 10px;
  font-size: 14px;
}

.titleRefZone{
  padding-top: 5px !important;
  margin-top: 5px !important;
  padding: 5px !important;
  margin: 5px !important;
}
</style>
